"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopoverArrow = void 0;
var _PopoverArrow = require("./PopoverArrow");
// TODO: in v9, move styled() from PopoverArrow.jsx to here
var StyledPopoverArrow = _PopoverArrow.PopoverArrow;
exports.StyledPopoverArrow = StyledPopoverArrow;